import { Injectable } from '@angular/core';


@Injectable()
export class CheckRoleService {
    
   

    isAdmin() {

       // Get current url.
        let url =  window.location.href;
        let pathArray = url.split( '/' );
        let findingItem = pathArray[3];
       

        if (findingItem == "admin") {
           
            return true;
           
        }
        
       
    }

}


// WEBPACK FOOTER //
// ./src/app/common/services/check-role.service.ts